import request from '../../utils/request'

export const getUserInfoService = (data: RequestData) => {
  return request('appGetUserInfo', {
    data,
  })
}

export const getUserResourcesService = (data: RequestData) => {
  return request('appGetUserResources', {
    data,
  })
}

export const logoutService = (data: RequestData) => {
  return request('appLogout', {
    data,
  })
}

export const getEntityIconService = (data: RequestData) => {
  return request('appQueryEntityIcon', { data })
}

export const getEntityBrandListService = (data: RequestData) => {
  return request('companyBrandListByUserType', { data })
}

export const getUIConfigService = (data: RequestData) => {
  return request('entityUiConfigQueryByEntityId', { data })
}
